import { render, staticRenderFns } from "./PostByGroupPieChart.vue?vue&type=template&id=165bc176&"
import script from "./PostByGroupPieChart.vue?vue&type=script&lang=js&"
export * from "./PostByGroupPieChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports